import { render, staticRenderFns } from "./chatSendMediaPreviewDialog.vue?vue&type=template&id=efd0c740&scoped=true"
import script from "./chatSendMediaPreviewDialog.vue?vue&type=script&lang=js"
export * from "./chatSendMediaPreviewDialog.vue?vue&type=script&lang=js"
import style0 from "./chatSendMediaPreviewDialog.vue?vue&type=style&index=0&id=efd0c740&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd0c740",
  null
  
)

export default component.exports